class PeriodoInput {
  static get $inject() {
    return ['$element', '$scope']
  }

  constructor(element, scope) {
    this.element = element
    this.scope = scope
    this.changeAction = this.changeAction.bind(this)
    this.validations = {
      timeRange: true,
      required: true
    }
  }

  get required() {
    return this.element.attr('required') || this.ngRequired
  }

  $onInit() {
    this.scope.$watch('$ctrl.dataInicial.getTime()', this.changeAction)
    this.scope.$watch('$ctrl.dataFinal.getTime()', this.changeAction)

    this.ngModelCtrl.$render = () => {
      if (this.ngModelCtrl.$viewValue) {
        const { inicial, final } = this.ngModelCtrl.$viewValue

        this.dataInicial = inicial
        this.dataFinal = final
      } else {
        this.dataInicial = null
        this.dataFinal = null
      }
    }

    this.validate()
  }

  changeAction() {
    this.validate()

    if ((this.dataInicial || this.dataFinal) && this.isValid) {
      const inicial = angular.copy(this.dataInicial)
      const final = angular.copy(this.dataFinal)

      if (inicial)
        inicial.setHours(0, 0, 0, 0)

      if (final)
        final.setHours(23, 59, 59, 999)

      this.ngModelCtrl.$setViewValue({ inicial, final })
    } else {
      this.ngModelCtrl.$setViewValue(null)
    }
  }

  validate() {
    this.validations.required = true

    if (this.dataInicial && this.dataFinal) {
      this.validations.timeRange = this.dataFinal.getTime() >= this.dataInicial.getTime()
    }

    if (this.isValid && this.required) {
      this.validations.required = !!(this.dataInicial && this.dataFinal)
    }

    Object
      .entries(this.validations)
      .forEach(([key, valid]) => this.ngModelCtrl.$setValidity(key, valid))
  }

  get isValid() {
    return Object.values(this.validations).every(e => e)
  }
}

angular.module('eficienciaFiscalModule').component('periodoInput', {
  controller: PeriodoInput,
  bindings: {
    ngRequired: '='
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  template: `
    <div>
      <input type="text" class="form-control" ng-model="$ctrl.dataInicial" ui-date>
      <div>até</div>
      <input type="text" class="form-control" ng-model="$ctrl.dataFinal" ui-date>
    </div>
  `
})
